import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  selectedRegion: null,
  selectedPlant: null
}

export const setRegionPlantStore = createSlice({
  name: 'setRegionPlant',
  initialState,
  reducers: {
    setSelectedRegion: (state, action) => {
      state.selectedRegion = action.payload
    },
    setSelectedPlant: (state, action) => {
      state.selectedPlant = action.payload
    }
  },
})

export const { 
  setSelectedRegion, 
  setSelectedPlant 
} = setRegionPlantStore.actions;

export default setRegionPlantStore.reducer;
